module.exports = __webpack_public_path__ + "img/Afloat - the rise, the fall, the ebb of Mumbais communities by the water.b715c38c.png";